import { ReactNode } from 'react'

interface DevPanelToggleOption {
  value: string
  label: string
}

export interface DevPanelToggleProps {
  options: DevPanelToggleOption[]
  value: string
  onChange: (v: string) => void
}

export interface DevPanelProps {
  title: string
  info?: string
  currentValue?: ReactNode
  actions?: ReactNode
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
  defaultX?: number
  defaultY?: number
}
